import {ChargingRateUnitType} from '../enums/charging.rate.unit.type.enum';
import {RecurrencyKindType} from '../enums/recurrency.kind.enum';
import {ChargingProfileKindType} from '../enums/charging.profile.kind.enum';
import {ChargingProfilePurposeType} from '../enums/charging.profile.purpose.enum';
import {ChargingSchedulePeriod} from './ChargingSchedulePeriod';

export class CreateChargingProfileRequest {
    private minChargingRate: number;
    private chargingRateUnit: ChargingRateUnitType;
    private startSchedule: Date;
    private durationInSeconds: number;
    private validFrom: Date;
    private validTo: Date;
    private recurrencyKind: RecurrencyKindType;
    private chargingProfileKind: ChargingProfileKindType;
    private chargingProfilePurpose: ChargingProfilePurposeType;
    private stackLevel: number;
    private description: string;
    private schedulePeriods: ChargingSchedulePeriod [];


    constructor(minChargingRate?: number, chargingRateUnit?: ChargingRateUnitType, startSchedule?: Date,
                durationInSeconds?: number, validFrom?: Date, validTo?: Date, recurrencyKind?: RecurrencyKindType,
                chargingProfileKind?: ChargingProfileKindType, chargingProfilePurpose?: ChargingProfilePurposeType,
                stackLevel?: number, description?: string, schedulePeriods: ChargingSchedulePeriod[] = []) {
        this.minChargingRate = minChargingRate;
        this.chargingRateUnit = chargingRateUnit;
        this.startSchedule = startSchedule;
        this.durationInSeconds = durationInSeconds;
        this.validFrom = validFrom;
        this.validTo = validTo;
        this.recurrencyKind = recurrencyKind;
        this.chargingProfileKind = chargingProfileKind;
        this.chargingProfilePurpose = chargingProfilePurpose;
        this.stackLevel = stackLevel;
        this.description = description;
        this.schedulePeriods = schedulePeriods;
    }

    get _minChargingRate(): number {
        return this.minChargingRate;
    }

    set _minChargingRate(value: number) {
        this.minChargingRate = value;
    }

    get _chargingRateUnit(): ChargingRateUnitType {
        return this.chargingRateUnit;
    }

    set _chargingRateUnit(value: ChargingRateUnitType) {
        this.chargingRateUnit = value;
    }

    get _startSchedule(): Date {
        return this.startSchedule;
    }

    set _startSchedule(value: Date) {
        this.startSchedule = value;
    }

    get _durationInSeconds(): number {
        return this.durationInSeconds;
    }

    set _durationInSeconds(value: number) {
        this.durationInSeconds = value;
    }

    get _validFrom(): Date {
        return this.validFrom;
    }

    set _validFrom(value: Date) {
        this.validFrom = value;
    }

    get _validTo(): Date {
        return this.validTo;
    }

    set _validTo(value: Date) {
        this.validTo = value;
    }

    get _recurrencyKind(): RecurrencyKindType {
        return this.recurrencyKind;
    }

    set _recurrencyKind(value: RecurrencyKindType) {
        this.recurrencyKind = value;
    }

    get _chargingProfileKind(): ChargingProfileKindType {
        return this.chargingProfileKind;
    }

    set _chargingProfileKind(value: ChargingProfileKindType) {
        this.chargingProfileKind = value;
    }

    get _chargingProfilePurpose(): ChargingProfilePurposeType {
        return this.chargingProfilePurpose;
    }

    set _chargingProfilePurpose(value: ChargingProfilePurposeType) {
        this.chargingProfilePurpose = value;
    }

    get _stackLevel(): number {
        return this.stackLevel;
    }

    set _stackLevel(value: number) {
        this.stackLevel = value;
    }

    get _description(): string {
        return this.description;
    }

    set _description(value: string) {
        this.description = value;
    }

    get _schedulePeriods(): ChargingSchedulePeriod[] {
        return this.schedulePeriods;
    }

    set _schedulePeriods(value: ChargingSchedulePeriod[]) {
        this.schedulePeriods = value;
    }
}
